export default {
  apiUrl: 'https://vma-legacy.happening.media/api',
  imageCDN: 'https://artinfo-images-350.s3.amazonaws.com/',
  isProd: false,
  searchCases: [
    '10', '11', '20', '21', '22', '24', '25', '26', '27', '30', '31', '32', '33', '34', '35', '37', '38', '39',
    '40', '41', '42', '44', '45', '46', '47', '48', '49', 'CUSTOM'
  ]
};
